import React, { useEffect, useRef, useState } from "react";
import "../index.css";
import airmaxDay from "../../../assets/mp4/airmaxDay.mp4";

import ScrollAnimado from "../../ScrollAnimado";
import ModalVideo from "../../ModalVideo";

export default function AirmaxDay() {
  const [menuAberto, setMenuAberto] = useState(false);
  const [linkVideo, setLinkVideo] = useState("");
  window.addEventListener("scroll", () => {
    setMenuAberto(false);
  });

  return (
    <>
      <ModalVideo linkVideo={linkVideo} setLinkVideo={setLinkVideo} />
      <div className="w-100 h-100 position-relative">
        <video autoPlay loop muted className="videoBackground">
          <source src={airmaxDay} type="video/mp4" />
          Seu navegador não suporta vídeos HTML5.
        </video>

        <div
          className="tituloHome tituloHome1 "
          onClick={() => {
            setLinkVideo(
              "https://player.vimeo.com/video/1090115482?h=6c80b503a9"
            );
          }}
        >
          Airmax Day
        </div>

        <div className="background"></div>
      </div>
    </>
  );
}
